import {
  approvalPolicyOptionsQuery,
  workspaceApprovalPoliciesQuery,
} from "@common/api/approval-policies"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { policyDefaults } from "../-components/form/schema"
import { PolicyMissing } from "../-components/policy-missing"
import { PolicyPage } from "../-components/policy-page"
import { UPDATE_FLOWS_PERMISSION } from "../-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/approval-flows/$policyId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      UPDATE_FLOWS_PERMISSION,
      "/settings/workspace/general",
    ),
  loader: async ({ context: { queryClient }, params: { policyId } }) => {
    const [policies] = await Promise.all([
      queryClient.ensureQueryData(workspaceApprovalPoliciesQuery()),
      queryClient.ensureQueryData(approvalPolicyOptionsQuery()),
    ])
    const entry = policies.policies.find(
      (candidate) => candidate.policy.id === policyId,
    )
    if (!entry) {
      throw redirect({
        to: "/settings/workspace/approval-flows",
        replace: true,
      })
    }
    return { breadcrumb: entry.policy.name }
  },
  component: EditPolicyPage,
})

function EditPolicyPage(): React.ReactElement {
  const { policyId } = Route.useParams()
  const { data } = useSuspenseQuery(workspaceApprovalPoliciesQuery())
  const entry = data.policies.find(
    (candidate) => candidate.policy.id === policyId,
  )

  return (
    <>
      {entry ? (
        <PolicyPage
          key={policyId}
          policy={entry.policy}
          defaults={policyDefaults(entry.policy)}
        />
      ) : (
        <PolicyMissing />
      )}
      <Outlet />
    </>
  )
}
